// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideBlock_root__E3eLb","title":"TravelGuideBlock_title__Nn7AI"};